import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { useAppSelector } from "@hooks/reduxHooks";
import useUserSwitcher from "@hooks/useUserSwitcher";

import Alert from "./Alert";
import Footer from "./Footer";
import Header from "./Header";
import PageHeader from "./PageHeader";
import ScoreTicker from "./ScoreTicker";
import Toasts from "./Toasts";
import TopBar from "./TopBar";

const Layout = (): React.JSX.Element => {
    const { user } = useAppSelector(state => state.auth);
    const { handleExitUserSwitch, isSimulatingUser } = useUserSwitcher();
    const isUserSwitched = isSimulatingUser();

    useEffect(() => {
        const nonProdMessage = document.getElementById("nonProdMessage");
        const simUserMessage = document.getElementById("simUserMessage");
        const scoreTickerWrapper =
            document.getElementById("scoreTickerWrapper");

        if (simUserMessage) {
            scoreTickerWrapper!.style.marginTop = `${simUserMessage.offsetHeight}px`;
        }

        if (nonProdMessage) {
            if (simUserMessage) {
                scoreTickerWrapper!.style.marginTop = `${simUserMessage.offsetHeight + nonProdMessage.offsetHeight}px`;
                simUserMessage!.style.marginTop = `${nonProdMessage.offsetHeight}px`;
            } else {
                scoreTickerWrapper!.style.marginTop = `${nonProdMessage.offsetHeight}px`;
            }
        }
    }, [isUserSwitched]);

    return (
        <div id="appRoot" data-testid="appRoot">
            {process.env.BUILD_ENV !== "production" && (
                <div
                    id="nonProdMessage"
                    className={process.env.BUILD_ENV}
                    data-testid="nonProdMessage"
                >
                    <p>
                        {`${process.env.BUILD_ENV?.slice(0, 1).toUpperCase()}${process.env.BUILD_ENV?.slice(1)}`}{" "}
                        Environment
                    </p>
                </div>
            )}
            {isUserSwitched && (
                <div id="simUserMessage" data-testid="simUserMessage">
                    <p>
                        You are currently logged in as {user?.firstName}{" "}
                        {user?.lastName}. Click{" "}
                        <span
                            onClick={() => handleExitUserSwitch()}
                            style={{
                                cursor: "pointer",
                                textDecoration: "underline",
                            }}
                        >
                            here
                        </span>{" "}
                        to return to your user.
                    </p>
                </div>
            )}
            <ScoreTicker />
            <TopBar />
            <Header />
            <main>
                <PageHeader />
                <Alert />
                <Outlet />
            </main>
            <Footer />
            <Toasts />
        </div>
    );
};

export default Layout;
